import React from 'react'
import { BASE_URL, FEMALE_DR_AVATAR, MALE_DR_AVATAR } from '../../../configurations/initUrls'

export default function Dp({ user, height = "h-36", width = "w-36", isNewUser = false }) {
    return (
        isNewUser ?
            user.isDP == 0 ?
                <img class={`${height} ${width} mb-1 rounded-full`} src={user.gender === 0 ? MALE_DR_AVATAR : FEMALE_DR_AVATAR} alt="Doctor Image" />
                :
                <img class={`${height} ${width} mb-1 rounded-full`} src={BASE_URL + "/" + user.dpUrl} alt="Doctor Image" />
            :
            user.isDP == 0 ?
                <img class={"inline-block " + height + " " + width + " rounded-full"} src={user.gender === 0 ? MALE_DR_AVATAR : FEMALE_DR_AVATAR} alt="Profile" />
                :
                <img class={"inline-block " + height + " " + width + " rounded-full"} src={BASE_URL + "/" + user.dpUrl} alt="Profile" />
    )
}
